<template>
    <b-container>
          <b-skeleton-wrapper :loading="loading">
      <template #loading>
        <b-card>
          Name: <b-skeleton width="85%"></b-skeleton>
          <b-skeleton width="55%"></b-skeleton>
          <b-skeleton width="75%"></b-skeleton>
        </b-card>
      </template>
        <h3>Name: {{ward.ward_name}}, {{ward.ward_city}}</h3>
        <h4>Subscribe for Notifications from your Ward</h4>
        <b-card>
        <b-form @submit="onSubmit">
        <b-row>
            <b-col>
              <b-form-group
                id="input-group-1"
                label="First Name:"
                label-for="input-1"
                description="First Name.">
                <b-form-input
                  id="input-1"
                  v-model="contact.first_name"
                  type="text"
                  placeholder="Enter First Name"
                  required ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="input-group-2"
                label="Last Name:"
                label-for="input-2"
                description="Contact last name.">
                  <b-form-input
                    id="input-2"
                    v-model="contact.last_name"
                    type="text"
                    placeholder="Enter Last Name"
                    required
                  ></b-form-input>
                  </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
        <b-form-group
            id="input-group-100"
            label="Phone Country Code"
            label-for="input-group-100"
            description="Set the tel country code if not US">
            <b-form-select
              :disabled="!contact.send_through_whatsapp"
              v-model="contact.phone_country_code"
              :options="countryCodeOptions"></b-form-select>
        </b-form-group>
            </b-col>
            <b-col>
        <b-form-group
            id="input-group-3"
            label="Phone Number:"
            label-for="input-3"
            description="Contact Phone Number.">
            <b-form-input
                id="input-3"
                v-model="contact.phone_number"
                type="tel"
                placeholder="Enter Contact Phone Number"
                required
                @input="acceptNumber"
            ></b-form-input>
        <b-form-checkbox
          v-if="ward.whatsapp_service_enabled"
        v-model="contact.send_through_whatsapp"
        name="check-button"
        switch>
            Use WhatsApp
        </b-form-checkbox>
        </b-form-group>
              </b-col>
            </b-row>
        <b-row>
            <b-col>
        <b-form-group
            id="input-group-10"
            label="Gender"
            label-for="input-group-10"
            description="Optional gender field, this will override the primary organization gender.">
            <b-form-select v-model="contact.gender" :options="genderOptions"></b-form-select>
        </b-form-group>
        </b-col>
        <b-col>
            <b-form-group
                            id="input-group-5"
                            label="Preferred Language"
                            label-for="input-5"
                            description="Preferred Language to receive messages in default is defined at ward/org level">
                            <b-form-select
                                v-model="contact.preferred_language"
                                :options="language_options"
                                ></b-form-select>
                        </b-form-group>
        </b-col>
        </b-row>
        <b-row>
            <b-col>
        <b-form-group
            id="input-group-4"
            label="Primary Organization/Group:"
            label-for="input-4"
            description="Primary Ward Organization/Group">
            <b-form-select
                id="input-3"
                v-model="contact.primary_organization"
                :options="primary_options"
                required
            ></b-form-select>
        </b-form-group>
        </b-col>
        </b-row>
        <b-button type="submit" variant="primary" class="mt-3" :disabled="subscribing"><b-spinner small v-if="subscribing"></b-spinner>{{subscribeText}}</b-button>
    </b-form>
    </b-card>
    </b-skeleton-wrapper>
    </b-container>
</template>
<script>
import { WardApi } from "@/app/wards/wardApi";
import { userMixin } from "@/mixins/userMixin";
import handleError from "@/errorHandler";

export default {
    name: "WardContactSignUp",
    mixins: [userMixin],
    props: {
        wardId: {
            type: String,
            required: true,
        },
        securityKey: {
          type: String,
          required: true
        }
    },
    data () {
        return {
            loading: true,
            subscribing: false,
            genderOptions: [],
            options: [],
            primary_options:[],
            organizations:[],
            language_options: [],
            contactTypeOptions: [],
            countryCodeOptions: [],
            contact :{
                ward_id : null,
                stake_id: null,
                first_name: null,
                last_name: null,
                phone_number: null,
                primary_organization: null,
                aux_organization: [],
                ward: {
                    ward_name: null,
                    ward_id: null
                },
                disabled: false,
                gender: null,
                preferred_language: null,
                send_through_whatsapp: false,
                phone_country_code: "+1"
            },
            ward: {
                ward_name: null,
                send_consent: false,
                whatsapp_service_enabled: false,
            }
        }
    },
    computed: {
      availableOptions() {
        return this.options.filter(opt => this.contact.aux_organization.indexOf(opt.value) === -1);
      },
      subscribeText () {
          if(!this.subscribing) {
              return "Subscribe";
          }
          return "Subscribing...";
      }
    },
    async mounted() {
        await this.fetchWardDetails();
        this.loading = false;
    },
    methods: {
        async fetchWardDetails() {
          try {
            const {data} = await WardApi.getWardPublic(this.wardId, this.securityKey);
            this.ward = data.ward;
            // map gender
            data.gender_types.forEach( x=> {
              this.genderOptions.push({
                value: x.gender_type,
                text: x.description,
                disabled: x.disabled
              })
            });
            // map country codes
            data.country_codes.forEach( x=> {
              this.countryCodeOptions.push(
                {
                  value: x.country_code,
                  text: x.description
                }
              );
            });
            // map ward languages
            data.ward_languages.forEach( x=> {
              this.language_options.push(
                {
                value: x.language_code,
                text: x.description
                }
              );
            });
            // primary organizations
            data.primary_organizations.forEach( x=> {
              this.primary_options.push(
                {
                  value: x.org_code,
                  text: x.org_name
                }
              )
            })
          } catch(e) {
                handleError(e, "Error trying to fetch ward");
            }
        },
        async onSubmit(event) {
            this.subscribing = true;
            event.preventDefault();
            try{
              this.contact.ward_id = this.ward.ward_id;
              this.contact.stake_id = this.ward.stake_id;
              this.contact.ward = null;
              const { data } = await WardApi.createPublicWardContact(this.wardId, this.contact);
              await this.$router.push({ name: 'home',params: { wardId: this.wardId}});
              this.$toast.success("Request submitted succesfully");
            } catch(e) {
                handleError(e, "Error trying to process subscription request");
            } finally {
              this.subscribing = false;
            }
        },
        acceptNumber() {
            var p = this.contact.phone_number.replace(/\D/g, '');
            var x = p.match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            if(p.length==11)
                x = p.match(/(\d{0,1})(\d{0,3})(\d{0,3})(\d{0,4})/);
            if(p.length===10){
                this.contact.phone_number = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
                return
            }
            if(p.length===11)
                this.contact.phone_number = !x[3] ? x[2] : '(' + x[2] + ') ' + x[3] + (x[4] ? '-' + x[4] : '');
        }
    }
}
</script>
<style lang="scss" scoped>
</style>
